module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdtSpeac"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('span', [_vm._v("MDT确认信息")])]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_c('cell', {
    attrs: {
      "title": "姓名",
      "readonly": ""
    },
    model: {
      value: (_vm.mdtInfo.patientName),
      callback: function($$v) {
        _vm.$set(_vm.mdtInfo, "patientName", $$v)
      },
      expression: "mdtInfo.patientName"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "卡号",
      "readonly": ""
    },
    model: {
      value: (_vm.mdtInfo.identityNo),
      callback: function($$v) {
        _vm.$set(_vm.mdtInfo, "identityNo", $$v)
      },
      expression: "mdtInfo.identityNo"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "电话",
      "readonly": ""
    },
    model: {
      value: (_vm.mdtInfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.mdtInfo, "phone", $$v)
      },
      expression: "mdtInfo.phone"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "看诊时间",
      "readonly": ""
    },
    model: {
      value: (_vm.visitTime),
      callback: function($$v) {
        _vm.visitTime = $$v
      },
      expression: "visitTime"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "入组条件",
      "readonly": ""
    },
    model: {
      value: (_vm.mdtInfo.pointerCancel),
      callback: function($$v) {
        _vm.$set(_vm.mdtInfo, "pointerCancel", $$v)
      },
      expression: "mdtInfo.pointerCancel"
    }
  }), _vm._v(" "), (_vm.mdtInfo.accept == 1) ? _c('cell', {
    staticStyle: {
      "color": "green"
    },
    attrs: {
      "title": "状态",
      "value": "同意"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mdtInfo.accept == 2) ? _c('cell', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "状态",
      "value": "已拒绝"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "备注",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.mdtInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.mdtInfo, "remark", $$v)
      },
      expression: "mdtInfo.remark"
    }
  })], 1), _vm._v(" "), (!_vm.mdtInfo.accept) ? _c('div', {
    staticClass: "btnGroup",
    attrs: {
      "align": "center"
    }
  }, [_c('x-button', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "warn",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureNo($event)
      }
    }
  }, [_vm._v("拒绝")]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureOk($event)
      }
    }
  }, [_vm._v("同意")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-367f468a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/mdt/mdtSpeacInfo.vue
// module id = OflK
// module chunks = 5